// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.scroll-container[data-v-7218dcc5] {
    height: 100%;
    max-height: none;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    scrollbar-width: thin;
    scrollbar-color: #888 #f0f0f0;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    padding-bottom: 80px; /* Increased padding at the bottom to prevent content from being cut off */
    position: relative;
}
.scroll-container[data-v-7218dcc5]::-webkit-scrollbar {
    width: 8px;
    z-index: 99999;
}
.scroll-container[data-v-7218dcc5]::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 10px;
    z-index: 99999;
}
.scroll-container[data-v-7218dcc5]::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
    z-index: 99999;
}
.scroll-container[data-v-7218dcc5]::-webkit-scrollbar-thumb:hover {
    background: #555;
    z-index: 99999;
}
.message-list[data-v-7218dcc5] {
  padding: 16px;
  padding-bottom: 100px; /* Extra padding at the bottom to ensure content isn't cut off */
  overflow-y: auto !important;
  overflow-x: hidden !important;
  background-color: white;
  scrollbar-width: thin;
  scrollbar-color: rgba(66, 133, 244, 0.3) transparent;
  height: 100%;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  background-image: linear-gradient(to bottom, rgba(245, 247, 250, 0.5), rgba(245, 247, 250, 0.2));
  max-width: 100%;
  position: relative;
  flex: 1 1 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.message-list[data-v-7218dcc5]::-webkit-scrollbar {
  width: 6px;
  z-index: 99999;
}
.message-list[data-v-7218dcc5]::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
  z-index: 99999;
}
.message-list[data-v-7218dcc5]::-webkit-scrollbar-thumb {
  background-color: rgba(66, 133, 244, 0.3);
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: content-box;
  z-index: 99999;
}
.message-list[data-v-7218dcc5]::-webkit-scrollbar-thumb:hover {
  background-color: rgba(66, 133, 244, 0.5);
  z-index: 99999;
}
.layout[data-v-7218dcc5] {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.fill-height[data-v-7218dcc5] {
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
  overflow: hidden;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
